export default "__VITE_ASSET__CMwPJdsv__"